import React from "react";
import { useSelector } from "react-redux";
import styles from "./ItemDiscount.module.scss";

interface IProps {
  handleCancelDiscount: any;
  setAndClose: any;
}
const ItemDiscount: React.FC<IProps> = ({
  handleCancelDiscount,
  setAndClose,
}) => {
  const { ticketItems, total, orderType, discountAmount, discountType } =
    useSelector((state: any) => state.ticketReducer);

  const handleDiscount = () => {};
  return (
    <div className={styles.overlay_model}>
      <div className={styles.success_model}>
        <div className={styles.success_model_container}>
          <div className={styles.item_list}>
            {ticketItems.map((item: any) => (
              <div className={styles.item}>
                <span>{item.ItemName}</span>
                <input type="number" placeholder="Enter discount amount" />
              </div>
            ))}
          </div>

          <div className={styles.btn_container}>
            <button
              onClick={() => {
                handleDiscount();
                setAndClose();
              }}
            >
              SET DISCOUNT
            </button>
            <button onClick={handleCancelDiscount}>CANCEL DISCOUNT</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ItemDiscount;
